var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "48px",
    viewBox: "0 0 69 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "57D65ACC-5871-43D4-B346-405A4CE9ADC5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Sprite",
    transform: "translate(-686.000000, -2111.000000)",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud-light",
    transform: "translate(686.000000, 2111.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8079861,10.6554688 C46.9166667,10.1322917 48.1652778,9.83333333 49.5,9.83333333 C54.2576389,9.83333333 58.1111111,13.6557292 58.1111111,18.375 C58.1111111,19.1971354 57.9927083,19.9765625 57.7881944,20.7239583 C57.346875,22.2721354 58.0572917,23.9270833 59.4888889,24.6851563 C62.771875,26.4041667 65,29.8208333 65,33.75 C65,39.4088542 60.3715278,44 54.6666667,44 L15.0555556,44 C8.39270833,44 3,38.6507813 3,32.0416667 C3,26.83125 6.35833333,22.4002604 11.0513889,20.7559896 C12.3753472,20.296875 13.2902778,19.0796875 13.3440972,17.6809896 C13.7100694,9.51302083 20.5020833,3 28.8333333,3 C34.0753472,3 38.7038194,5.57317708 41.5131944,9.534375 C42.4819444,10.8903646 44.2902778,11.3708333 45.8079861,10.6554688 Z M44.85,8.01428571 C41.4107813,3.16071429 35.7398437,0 29.325,0 C19.1259375,0 10.8135938,7.99285714 10.3715625,18.0107143 C4.3340625,20.1321429 0,25.8428571 0,32.5714286 C0,41.0892857 6.95390625,48 15.525,48 L55.2,48 C62.8223438,48 69,41.8607143 69,34.2857143 C69,29.025 66.0135937,24.45 61.6364063,22.1571429 C61.9382813,21.1071429 62.1,20.0035714 62.1,18.8571429 C62.1,12.225 56.6985937,6.85714286 50.025,6.85714286 C48.170625,6.85714286 46.4132812,7.275 44.85,8.01428571 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudLight);
export default __webpack_public_path__ + "static/media/cloud-light.d4627924adcd98d9377b1c7bf63de7e7.svg";
export { ForwardRef as ReactComponent };